﻿import React from 'react';
import Lottie from 'lottie-react';

import xmasAnimData from '../../AnimationFiles/snowglobe-top.json';

const SeasonalSnowGlobeHeroAnimation = () => {

    const lottieRef = React.useRef();

    React.useEffect(() => {

        setTimeout(() => {
            lottieRef.current.play();
        }, 100)
    },[])

    return (
        <Lottie
            className="animated-hero__inner__animation__holder__element"
            lottieRef={lottieRef}
            autoplay={false}
            loop={true}
            animationData={xmasAnimData}
        />
     )
 }                

export default SeasonalSnowGlobeHeroAnimation;